/**
 * CropCtrl controller
 * Crop image
 */

/**
 * CropCtrl controller
 *
 * @class CropCtrl
 *
 * @ngdoc controller
 * @name mwApp/crop.controller:CropCtrl
 */
/* @ngInject */
export default function CropCtrl ($scope, $uibModalInstance, file, options, restrictions, alertLiteSvc) {
  var vm = this

  // loader
  $scope.loading = true
  $scope.validatioError = false

  // cropper instance
  vm.cropper = null

  vm.restrictions = restrictions

  if (window.URL) {
    vm.img = window.URL.createObjectURL(file)
    validateImage()
  } else {
    const reader = new window.FileReader()
    reader.onload = function (e) {
      vm.img = reader.result
      validateImage()
    }
    reader.readAsDataURL(file)
  }

  /**
   * Validate image by restrictions
   */
  function validateImage () {
    const img = new window.Image()
    img.src = vm.img
    img.onload = function () {
      const minDimensions = restrictions.minDimensions
      const maxResolution = restrictions.maxResolution

      if (minDimensions) {
        const [minWidth, minHeight] = minDimensions.split('x')
        if (minWidth && +minWidth > this.width) {
          // alertLiteSvc.alert(`Width for selected file is lower than ${minWidth}px`, 'danger')
          $scope.validatioError = true
        }
        if (minHeight && +minHeight > this.height) {
          // alertLiteSvc.alert(`Height for selected file is lower than ${minHeight}px`, 'danger')
          $scope.validatioError = true
        }
      }

      if(maxResolution && maxResolution < this.width * this.height ) {
          $scope.validatioError = true
      }

      $scope.loading = false
    }
  }

  /**
   * Cropper options
   *
   * @memberof mwApp/seasons.controller:CropCtrl
   */
  vm.options = {
    viewMode: 1,
    dragMode: 'move',
    cropBoxResizable: true,
    minContainerHeight: 600,
    toggleDragModeOnDblclick: false,
    ...options
  }

  /**
   * Crop image
   *
   * @memberof mwApp/seasons.controller:CropCtrl
   */
  vm.crop = function () {
    vm.setDisable()

    if (vm.cropper) {
      const canvas = vm.cropper.getCroppedCanvas()

      $uibModalInstance.close(canvas)
    }
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/seasons.controller:CropCtrl
   */
  vm.cancel = function () {
    $scope.$broadcast('cropper.destroy', true)
    $uibModalInstance.dismiss('cancel')
  }
}
